import React from 'react';
import { useLocation } from 'react-router-dom';
import routes from '../../routes';
import GlobalHeader from '../global-header';
import './main-layout.scss';
import GlobalFooter from '../global-footer';
import PrivacyStatementModal from '../global-footer/PrivacyStatementModal';

const MainLayout = ({ children }) => {
  const [isFullPage, setFullPage] = React.useState(false);

  const location = useLocation();
  React.useEffect(() => {
    const currentRoute = routes.find((route) => route.path?.includes(location.pathname));
    // debug-console.log('MainLayout: path=' + location.pathname + ' -> route=' + currentRoute?.path);
    if (currentRoute) {
      setFullPage(currentRoute.isFullPage);
    }
  }, [location]);
  if (isFullPage)
    return (
      <div className="main-layout-fullpage-root">
        <div className="content-page-full">{children}</div>
      </div>
    );
  return (
    <div className="main-layout-fullpage-root">
      {/* <GlobalHeader /> */}
      <div className="content-page">
        <GlobalHeader />
        <div className="real-content">{children}</div>
        <GlobalFooter />
      </div>
    </div>
  );
};

export default MainLayout;
